// @flow
import { url as urlUtils } from '@clubmed/utils';

import { RESORT_BOOKING_BE } from 'Client/cms/toolkit/constants';
import graphQLClient from 'Utils/graphql-client/graphqlClient';
import * as configQueries from 'Views/configQueries';
import { LINE_PRODUCT_BOOKING } from 'Utils/request/requestDictionary';
import { type ProductBookingDescriptorProps } from 'Components/lines/product-booking-line/ProductBookingLine.utils';

export const productBookingBEResolver = {
  name: RESORT_BOOKING_BE,
  resolve(
    appContext: AppContext,
    props: ProductBookingDescriptorProps,
    pageContext: PageContext,
    location: ProductRouterLocation,
  ) {
    const offerName = location.queryParams.offer
      ? urlUtils.decodePath(location.queryParams.offer)
      : '';
    const { resortId } = props;
    const resortArgs = `resortId: "${resortId}"`;
    const offerArgs = `offerName: "${offerName}"`;
    const cmsArgs = `content: "${appContext.cmsContent}" release: "${appContext.cmsRelease}"`;

    return graphQLClient.runQuery('', appContext, {
      requestName: LINE_PRODUCT_BOOKING,
      queryId: LINE_PRODUCT_BOOKING,
      prebuiltArgs: {
        resortArgs,
        resortId,
        cmsArgs,
        offerArgs,
        minAgeInformation: props.minAgeInformation,
        minAgeErrorMessage: props.minAgeErrorMessage,
        resortStartingPrice: configQueries.resortStartingPrice(),
      },
    });
  },
};
